import windowLoaded from './windowLoaded'

export default {
  boot: (user?: any) => {
    const dataLayer: any = (window as any).dataLayer || []
    if (user && user.misc && user.misc.user_email_hash) {
      dataLayer.push({ userEmailHash: user.misc.user_email_hash })
    }
    windowLoaded().then(() => dataLayer.push({ event: 'pinterestReady' }))
  }
}
